import { render, staticRenderFns } from "./ItemListHomeCollectLayout.vue?vue&type=template&id=d29a5a08&scoped=true"
import script from "./ItemListHomeCollectLayout.vue?vue&type=script&lang=js"
export * from "./ItemListHomeCollectLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29a5a08",
  null
  
)

export default component.exports